export const PROFILE_IMAGE_WIDTH = 512;
export const PROFILE_IMAGE_HEIGHT = 512;
export const COVER_IMAGE_WIDTH = 2048;
export const COVER_IMAGE_HEIGHT = 512;
